import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { TrimesterAccVenture } from '@interfaces';
import { DomainDataService } from '../../../../../../services';
import { DeliveryAreaService } from '../../../../delivery-area.service';
import { DeliveryOverviewService } from '../../../delivery-overview.service';
import { getSetup } from './grid/get-setup';

export interface DeliveryAccVenture extends TrimesterAccVenture {
	accName: string,
	entrepreneurNames: string | undefined,
	industry: string | undefined,
	dropoutReason: string | undefined,
}


@Component({
	selector: 'delivery-all-ventures-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './all-ventures-view.part.html',
})
export class DeliveryAllVenturesViewPart {

	private readonly util = inject(UtilityService);
	private readonly dialogService = inject(DialogService);
	private readonly domain = inject(DomainDataService);
	private readonly pageService = inject(DeliveryOverviewService);
	private readonly areaService = inject(DeliveryAreaService);

	// setup is computed bcoz selectedTrimesterName is dynamic and can change, affecting the download file name.
	public setup = computed(() => getSetup(this.util, this.dialogService, this.areaService));

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public allVentures = computed<DeliveryAccVenture[]>(() => {
		const data = this.areaService.deliveryData();

		if (!data) return [];

		const accById = this.util.array.toMap(data.accelerators, a => a.accId);

		return data.allVentures.map(v => {
			return {
				...v,
				accName: accById[v.accId]?.name ?? '',
				entrepreneurNames: v.entrepreneurs.map(e => e.name).join(', '),
				industry: this.domain.data().industries[v.industryId]?.name,
				dropoutReason: v.dropout ? this.domain.data().dropoutReasonsMap[v.dropout.dropoutReasonId]?.name : undefined,
			};
		});
	});
}